/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Row5_KbInputs */

const en_mk_cmp_row5_kb = /** @type {(inputs: Mk_Cmp_Row5_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visible and correctable by the team`)
};

const id_mk_cmp_row5_kb = /** @type {(inputs: Mk_Cmp_Row5_KbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa dilihat & dikoreksi tim`)
};

/**
* | output |
* | --- |
* | "Visible and correctable by the team" |
*
* @param {Mk_Cmp_Row5_KbInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_row5_kb = /** @type {((inputs?: Mk_Cmp_Row5_KbInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Row5_KbInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_row5_kb(inputs)
	return en_mk_cmp_row5_kb(inputs)
});